(function () {
  function ensureSwiper(section, callback) {
    if (window.Swiper) return callback();

    var existing = document.querySelector('script[src*="swiper-bundle.min.js"]');
    if (existing) return existing.addEventListener("load", callback, { once: true });

    var script = document.createElement("script");
    script.src = section.dataset.swiperSrc;
    script.async = true;
    script.addEventListener("load", callback, { once: true });
    document.head.appendChild(script);
  }

  function bindAutoplayPause(section, swiper, signal) {
    function stop() {
      if (swiper.autoplay) swiper.autoplay.stop();
    }

    function start() {
      if (swiper.autoplay) swiper.autoplay.start();
    }

    section.addEventListener("mouseenter", stop, { signal: signal });
    section.addEventListener("mouseleave", start, { signal: signal });
    section.addEventListener("focusin", stop, { signal: signal });
    section.addEventListener("focusout", function (event) {
      if (!section.contains(event.relatedTarget)) start();
    }, { signal: signal });
  }

  function createSwiper(element, options) {
    return new Swiper(element, {
      slidesPerView: 1,
      autoHeight: Boolean(options.autoHeight),
      rewind: options.count > 1,
      speed: options.speed == null ? 300 : options.speed,
      autoplay: options.autoplay === false
        ? false
        : options.count > 1
          ? { delay: 5000, disableOnInteraction: false }
          : false,
      simulateTouch: true,
      allowTouchMove: true,
      resistance: true,
      resistanceRatio: 0.85,
      effect: options.effect || "slide",
      fadeEffect: options.fadeEffect || undefined,
      watchOverflow: true,
      resizeObserver: true,
      observer: true,
      observeParents: true,
      pagination: options.pagination ? { el: options.pagination, clickable: true } : false,
      navigation: options.navigation || false,
      on: options.on || {},
    });
  }

  function initDesktop(section, state) {
    var iconElement = section.querySelector("[data-testimonial-desktop-icon]");
    var element = section.querySelector("[data-testimonial-desktop-content]");
    var pagination = section.querySelector("[data-testimonial-desktop-pagination]");
    var count = element ? element.querySelectorAll(".swiper-slide").length : 0;
    var tabs = section.querySelectorAll("[data-testimonial-desktop-tab]");
    if (!iconElement || !element) return;

    function setActive(index) {
      tabs.forEach(function (tab, tabIndex) {
        tab.classList.toggle("is-active", tabIndex === index);
      });
    }

    var iconSwiper = new Swiper(iconElement, {
      slidesPerView: "auto",
      spaceBetween: 24,
      allowTouchMove: false,
      watchOverflow: true,
      resizeObserver: true,
      observer: true,
      observeParents: true,
    });

    var contentSwiper = createSwiper(element, {
      count: count,
      speed: 0,
      effect: "fade",
      fadeEffect: { crossFade: true },
      pagination: pagination,
      navigation: {
        prevEl: section.querySelector(".testimonial-icon-carousel__arrow--prev"),
        nextEl: section.querySelector(".testimonial-icon-carousel__arrow--next"),
      },
      on: {
        slideChange: function () {
          setActive(this.realIndex);
          iconSwiper.slideTo(this.realIndex, 300);
        },
      },
    });

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        contentSwiper.slideTo(Number(tab.dataset.testimonialDesktopTab));
      }, { signal: state.abort.signal });
    });

    setActive(0);
    bindAutoplayPause(section, contentSwiper, state.abort.signal);
    state.swipers.push(iconSwiper, contentSwiper);
  }

  function initMobile(section, state) {
    var iconElement = section.querySelector("[data-testimonial-mobile-icon]");
    var contentElement = section.querySelector("[data-testimonial-mobile-content]");
    var pagination = section.querySelector("[data-testimonial-mobile-pagination]");
    var count = contentElement ? contentElement.querySelectorAll(".swiper-slide").length : 0;
    if (!iconElement || !contentElement) return;

    var syncing = false;
    var iconSwiper = createSwiper(iconElement, {
      count: count,
      autoplay: false,
      on: {
        slideChange: function () {
          if (!syncing && contentSwiper) contentSwiper.slideTo(this.realIndex, 300);
        },
      },
    });

    var contentSwiper = createSwiper(contentElement, {
      count: count,
      autoHeight: false,
      speed: 0,
      effect: "fade",
      fadeEffect: { crossFade: true },
      pagination: pagination,
      on: {
        slideChange: function () {
          syncing = true;
          iconSwiper.slideTo(this.realIndex, 0);
          syncing = false;
        },
      },
    });

    bindAutoplayPause(section, contentSwiper, state.abort.signal);
    state.swipers.push(iconSwiper, contentSwiper);
  }

  function destroy(section) {
    var state = section._testimonialCarousel;
    if (!state) return;
    state.media.removeEventListener("change", state.sync);
    state.abort.abort();
    state.swipers.forEach(function (swiper) {
      swiper.destroy(true, true);
    });
    delete section._testimonialCarousel;
  }

  function init(section) {
    destroy(section);

    var state = {
      abort: new AbortController(),
      media: window.matchMedia("(max-width: 767px)"),
      swipers: [],
    };

    state.sync = function () {
      state.abort.abort();
      state.abort = new AbortController();
      state.swipers.forEach(function (swiper) {
        swiper.destroy(true, true);
      });
      state.swipers = [];

      ensureSwiper(section, function () {
        if (section._testimonialCarousel !== state || !section.isConnected) return;
        if (state.media.matches) initMobile(section, state);
        else initDesktop(section, state);
      });
    };

    section._testimonialCarousel = state;
    state.sync();
    state.media.addEventListener("change", state.sync);
  }

  function initAll(root) {
    (root || document).querySelectorAll("[data-testimonial-icon-carousel]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-testimonial-icon-carousel]").forEach(destroy);
  });
})();
